import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import { DICTIONARY_CODE } from "@/utils/pattern"
import { BASE_URL } from "@/api/system/dictionary-data"

/**
 * 绘制编辑表单
 */
export function renderAddForm(el: Element) {
  const editForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL,
    },
    '新增'
  )

  return editForm
}

const items = [
  [
    createFormItem('数据名称', 'dataName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' })
  ],
  [
    createFormItem('数据编码', 'dataCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  ],
  [
    createFormItem('数据值', 'dataValue', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  ],
  [
    createFormItem('顺序', 'sort', FORM_ITEM.INPUT_NUMBER, { controlsPosition: 'right', min: 0 }),
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'EOD', default: true }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]
const rules = {
  dataName: [{ required: true, message: '请输入数据名称', trigger: 'blur' }],
  dataCode: [{ required: true, message: '请输入数据代码', trigger: 'blur' },
    { pattern: DICTIONARY_CODE, message: '只能包含小写字母、数字、下划线', trigger: 'blur' }],
  dataValue: [{ required: true, message: '请输入数据值', trigger: 'blur' }],
  sort: [{ required: true, message: '请输入顺序', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
}